export const ClockIcon = ({ style = {}, width = '100%', className = '', height = '100%', viewBox = '0 0 150 150' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={viewBox}
    className={className}
    style={{ ...style }}
    fill="none"
  >
    <g transform="translate(31.5,62.5)" clipPath="url(#clip0_6744_20874)">
      <circle
        cx="42.9146"
        cy="42.9158"
        r="17.0625"
        transform="rotate(128.544 42.9146 42.9158)"
        stroke="url(#paint0_linear_6744_20874)"
        strokeOpacity="0.15"
        strokeWidth="9.63333"
      />
      <circle
        cx="42.9163"
        cy="42.9156"
        r="26.681"
        transform="rotate(-150.542 42.9163 42.9156)"
        stroke="url(#paint1_linear_6744_20874)"
        strokeOpacity="0.13"
        strokeWidth="9.63333"
      />
      <path
        // eslint-disable-next-line max-len
        d="M43.0651 28.3333C35.2593 28.3333 28.8984 34.6941 28.8984 42.5C28.8984 50.3058 35.2593 56.6666 43.0651 56.6666C50.8709 56.6666 57.2318 50.3058 57.2318 42.5C57.2318 34.6941 50.8709 28.3333 43.0651 28.3333ZM49.2276 47.5575C49.1567 47.6782 49.0625 47.7836 48.9504 47.8676C48.8384 47.9516 48.7108 48.0126 48.5751 48.0468C48.4393 48.0811 48.2981 48.088 48.1596 48.0673C48.0211 48.0465 47.8882 47.9984 47.7684 47.9258L43.3768 45.305C42.2859 44.6533 41.4784 43.2225 41.4784 41.9616V36.1533C41.4784 35.5725 41.9601 35.0908 42.5409 35.0908C43.1218 35.0908 43.6034 35.5725 43.6034 36.1533V41.9616C43.6034 42.4716 44.0284 43.2225 44.4676 43.4775L48.8593 46.0983C49.3693 46.3958 49.5393 47.0475 49.2276 47.5575Z"
        fill="#098F50"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_6744_20874"
        x1="42.9146"
        y1="21.0367"
        x2="42.9146"
        y2="64.795"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1AA85D" />
        <stop offset="1" stopColor="#1AA85D" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6744_20874"
        x1="66.6686"
        y1="12.7089"
        x2="42.9163"
        y2="74.4133"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1AA85D" stopOpacity="0" />
        <stop offset="1" stopColor="#1AA85D" />
      </linearGradient>
      <clipPath id="clip0_6744_20874">
        <rect width="150" height="150" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
